export enum HistoryType {
  Education = 1,
  Work = 2,
}

export interface IOccupation {
  applicationId: number;
  occupationCode: string; // embassy code from drop down
  occupationName: string;
  occupationNameOther?: string;
}

export interface ICurrentEducation {
  collegeCode: string;
  collegeName: string;
  collegeNameOther: string;
  courseName: string;
  dateFrom: string;
  dateTo?: string;
}

export interface IHistory {
  historyType: HistoryType;
  name: string;
  dateFrom: string;
  dateTo?: string;
  details: string;
}

export interface IApplicantProfessionalHistory {
  applicantId: number;
  fulltimeStudent: boolean;
  occupation?: IOccupation;
  currentEducation?: ICurrentEducation;
  history?: IHistory[];
}

export interface ICriminalIssue {
  issueId: number;
  applicationId: number;
  type: number;
  subType: number;
  status: number;
  dateRaised: string;
  dateClosed?: string;
  raisedBy: string;
  raisedByApplicant: boolean;
  active: boolean;
  typeDescription: string;
  subTypeDescription: string;
  statusDescription: string;
  offenceName: string;
  offenceNameOther: string;
  offenceDate: string;
  offenceOutcome: string;
  offenceCircumstances: string;
  lastUpdated: string;
}

export interface IApplicationCriminalSummary {
  issues: ICriminalIssue[];
}

export class Occupation implements IOccupation {
  applicationId: number;
  occupationCode: string; // embassy code from drop down
  occupationName: string;
  constructor(applicationId: number, code: string, name: string) {
    this.applicationId = applicationId;
    this.occupationCode = code;
    this.occupationName = name;
  }
}

export class CurrentEducation implements ICurrentEducation {
  collegeCode: string;
  collegeName: string;
  collegeNameOther: string = '';
  courseName: string;
  dateFrom: string;
  dateTo?: string;
  constructor(
    code: string,
    name: string,
    course: string,
    dateFrom: string,
    dateTo?: string
  ) {
    this.collegeCode = code;
    this.collegeName = name;
    this.courseName = course;
    this.dateFrom = dateFrom;
    this.dateTo = dateTo;
  }
}

export class HistoryItem implements IHistory {
  historyType: HistoryType;
  name: string;
  dateFrom: string;
  dateTo?: string;
  details: string;
  constructor(
    type: HistoryType,
    name: string,
    dateFrom: string,
    dateTo: string | undefined,
    details: string
  ) {
    this.historyType = type;
    this.name = name;
    this.dateFrom = dateFrom;
    this.dateTo = dateTo;
    this.details = details;
  }
}

export class ProfessionalHistory implements IApplicantProfessionalHistory {
  applicantId: number;
  fulltimeStudent: boolean;
  occupation?: IOccupation;
  currentEducation?: ICurrentEducation;
  history?: IHistory[];
  constructor(applicantId: number, fulltimeStudent: boolean) {
    this.applicantId = applicantId;
    this.fulltimeStudent = fulltimeStudent;
  }

  getEducationHistory(): IHistory[] {
    const h = this.history?.filter(
      (h) => h.historyType === HistoryType.Education
    );
    return h ?? [];
  }

  getWorkHistory(): IHistory[] {
    const h = this.history?.filter((h) => h.historyType === HistoryType.Work);
    return h ?? [];
  }
}
